import { render, staticRenderFns } from "./VerifyDomain.vue?vue&type=template&id=efaa41e0&scoped=true&"
import script from "./VerifyDomain.vue?vue&type=script&lang=js&"
export * from "./VerifyDomain.vue?vue&type=script&lang=js&"
import style0 from "./VerifyDomain.vue?vue&type=style&index=0&id=efaa41e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaa41e0",
  null
  
)

export default component.exports